import { Iframe } from "./Iframe";
import { Tab } from "./sample/Tab";

export const Inventories = () => {
  return (
    <Tab>
      <Iframe url="inventories-employee" />
    </Tab>
  );
};
